import { geonameService } from "@/_services";

export const geoname = {
  namespaced: true,
  state: {
    paises: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getPaisesRequest(state) {
      state.paises.status = {
        loading: true,
      };
    },
    cancelPaisesRequest(state, error) {
      state.paises.data = [];
      state.paises.status = {
        error,
      };
    },
    getPaisesSuccess(state, paises) {
      state.paises.data = paises;
      state.paises.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getPaises({ commit }, filters) {
      commit("getPaisesRequest");
      geonameService
        .getPaises(filters)
        .then((paises) => {
          commit("getPaisesSuccess", paises);
        })
        .catch((error) => {
          commit("cancelPaisesRequest", error);
        });
    },
  },
};
